/**
 * AutoPhase - 自動処理フェーズUIコンポーネント
 *
 * FRONTEND.md Step.3 準拠:
 * - Lovable スタイル適用済み
 *
 * @see FRONTEND.md
 * @see src/types/ui-interfaces.ts
 */

import type { AutoPhaseProps } from '../../types/ui-interfaces';
import { useTranslations } from '../../i18n';

/**
 * Phase 6-8, 10: 自動処理フェーズUI
 *
 * 機能:
 * - 自動処理の進行状況表示
 * - Phase 9: ダイスロール結果表示
 * - クリックで次フェーズへ進行
 * - フローティングテキスト表示
 */
export function AutoPhase({
  phaseTitle: _phaseTitle,
  phaseDescription,
  phaseNumber,
  player: _player,
  floatingText,
  onProceed,
  diceAnimating: _diceAnimating = false,
  diceValues: _diceValues,
}: AutoPhaseProps) {
  const t = useTranslations();

  return (
    <div className="space-y-3">
      {/* 自動処理表示（クリック可能） */}
      <button
        className={`w-full p-3 bg-muted/50 rounded text-center transition-all ${
          onProceed
            ? 'hover:bg-primary/20 hover:border-primary cursor-pointer border-2 border-transparent'
            : ''
        }`}
        data-phase-number={phaseNumber}
        onClick={onProceed}
        disabled={!onProceed}
      >
        <h2 className="font-heading text-sm font-semibold">{t.autoPhase.title}</h2>
        <p className="text-xs text-muted-foreground mt-1">{phaseDescription}</p>

        {/* フローティングテキスト */}
        {floatingText && (
          <div className="mt-2 text-lg font-bold text-primary animate-bounce">
            {floatingText}
          </div>
        )}
      </button>

      {/* 次フェーズへの案内 */}
      {onProceed ? (
        <div className="text-sm text-primary text-center font-medium animate-pulse">
          {t.autoPhase.clickToProceed}
        </div>
      ) : (
        <div className="text-xs text-muted-foreground text-center animate-pulse">
          {t.autoPhase.processing}
        </div>
      )}
    </div>
  );
}

export default AutoPhase;
